import { render } from "./StaffPagination.vue?vue&type=template&id=5ac8857f&scoped=true"
import script from "./StaffPagination.vue?vue&type=script&lang=js"
export * from "./StaffPagination.vue?vue&type=script&lang=js"

import "./StaffPagination.vue?vue&type=style&index=0&id=5ac8857f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac8857f"]])

export default __exports__